import { connect } from 'react-redux'
import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import scenes from 'helpers/fovPreview/scenes'
import { updateUiAction } from 'actions/uiActions'
import { batchUpdateCalculatorAction } from 'actions/calculatorActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import keys from 'ramda/src/keys'
import equals from 'ramda/src/equals'
import compose from 'ramda/src/compose'
import append from 'ramda/src/append'
import without from 'ramda/src/without'
import unless from 'ramda/src/unless'

const mapStateToProps = ({ ui }) => ({
  showSceneSelector: EXPORT ? false : !!ui.showSceneSelector
})

const userUploadedSceneSelected = (userUploadedSceneUrl, id, batchUpdateCalculatorAction, updateUiAction) => {
  batchUpdateCalculatorAction({ userUploadedSceneUrl, userUploadedSceneActive: true },
                              [ 'userUploadedSceneUrl', 'userUploadedSceneActive' ], id, false)
  updateUiAction({ showSceneSelector: false })
}

class SceneSelector extends React.Component {
  updateScene = arg => {
    this.props.updateScene(arg)
  }

  sceneThumbnail = (name, i) => {
    const current = equals(this.props.currentScene, scenes[name])
    return (
      <div
        onClick={this.updateScene.bind(this, { sceneName: name })}
        className={current ? this.props.classes.sceneThumbnailCurrent : this.props.classes.sceneThumbnail}
        key={i}
      >
        <img src={scenes[name]} />
      </div>
    )
  }

  appendFisheye = compose(append('360'), append('180'), without(['180', '360']))

  render() {
    const { props: { currentCamera: { userUploadedSceneUrl, id, model }, updateUiAction, currentScene, showSceneSelector, streetViewAvailable,
      batchUpdateCalculatorAction, streetViewUrl, checkOfflineLimitsAction, classes }, updateScene, sceneThumbnail, appendFisheye } = this
    return (
      <div className={showSceneSelector ? classes.container : classes.hide}>
        <div
          className={streetViewAvailable ? classes.uploadSceneButton : classes.uploadSceneButtonFull}
          onClick={_ => checkOfflineLimitsAction('modal', ['FovUploadsForm'])}
        >
          {userUploadedSceneUrl ? 'Replace Your Scene' : 'Add Your Own Scene'}
        </div>
        {
          streetViewAvailable && (
            <div
              onClick={updateScene.bind(this, {})}
              className={classes.sceneSelectorButton}
            >
              {currentScene === streetViewUrl ? 'Street View - selected' : 'Street View'}
            </div>
          )
        }
        { userUploadedSceneUrl && (
          <div
            onClick={userUploadedSceneSelected.bind(null, userUploadedSceneUrl, id, batchUpdateCalculatorAction, updateUiAction)}
            className={userUploadedSceneUrl === currentScene ? classes.sceneThumbnailCurrent : classes.sceneThumbnail}
          >
            <img src={userUploadedSceneUrl} />
          </div>
        )
        }
        { (unless(_ => model && model.is_fisheye, appendFisheye)(keys(scenes))).map(sceneThumbnail) }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, batchUpdateCalculatorAction, checkOfflineLimitsAction })(injectSheet(style)(SceneSelector))



// WEBPACK FOOTER //
// ./src/components/SceneSelector/index.js